export default function (string1: string, string2: string): string {
  if (!string1 || !string2) return string2;
  let result = "";
  const parseString1 = string1?.trim().split(" ");
  const parseString2 = string2?.trim().split(" ");
  for (let i = 0; i < Math.max(parseString1.length, parseString2.length); i++) {
    if (result.length > 0) {
      result += " ";
    }
    if (parseString1[i]?.toUpperCase() !== parseString2[i]?.toUpperCase()) {
      result += `<span class="text-brand-500 font-bold">${
        parseString2[i] ? parseString2[i] : ""
      }</span>`;
    } else {
      result += parseString2[i] ? parseString2[i] : "";
    }
  }
  return result;
}
